import { extractProperty } from "utils"
import { StateType } from "../ProductsLobby"
import { filterProducts } from "./filterProducts"

const getStateByFilterKey = (
  initialState: StateType,
  state: StateType,
  filterKey: keyof StateType,
  allowedSubCategories: any[],
  allowedKeyFeatures: any[],
) => {
  let newState = { ...state }
  switch (filterKey) {
    case "categories":
      newState = {
        ...state,
        ["subCategories"]: initialState.subCategories
          .filter(
            (subCategory) =>
              allowedSubCategories.some((item: any) => item === subCategory.value) ||
              subCategory.number === 0,
          )
          .map((subCategory) => ({ ...subCategory, visibility: false })),
        ["productKeyFeatures"]: initialState.productKeyFeatures
          .filter(
            (keyFeature) =>
              allowedKeyFeatures.some((item: any) => item === keyFeature.value) ||
              keyFeature.number === 0,
          )
          .map((keyFeature) => ({ ...keyFeature, visibility: false })),
      }
      break
    case "subCategories":
      newState = {
        ...state,
        ["productKeyFeatures"]: initialState.productKeyFeatures
          .filter(
            (keyFeature) =>
              allowedKeyFeatures.some((item: any) => item === keyFeature.value) ||
              keyFeature.number === 0,
          )
          .map((keyFeature) => ({ ...keyFeature, visibility: false })),
      }
      break
    default:
      break
  }
  return newState
}

const setNewFilterList = (
  initialState: StateType,
  state: StateType,
  filterKey: keyof StateType,
  products: any,
): StateType => {
  const filteredProducts = filterProducts(products, state)

  const allowedSubCategories = [
    ...new Set(
      filteredProducts?.map((product: any) => {
        const properties = product.properties || []
        const subCategory = properties.find((p: any) => p.propertyName === "productSubCategory")
          ?.propertyValue?.value
        return subCategory
      }),
    ),
  ]

  const allowedKeyFeatures = [
    ...new Set(
      filteredProducts
        ?.map((product: any) => {
          const properties = product.properties || []
          const features = properties
            .find((p: any) => p.propertyName === "productKeyFeatures")
            ?.propertyValue?.blocks?.map((feature: any) => extractProperty(feature, "text"))
          return features
        })
        ?.flat(),
    ),
  ]

  return getStateByFilterKey(
    initialState,
    state,
    filterKey,
    allowedSubCategories,
    allowedKeyFeatures,
  )
}

export default setNewFilterList
